import { render } from "./CoachRegisteration.vue?vue&type=template&id=340a9fb1"
import script from "./CoachRegisteration.vue?vue&type=script&lang=js"
export * from "./CoachRegisteration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__